/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: cGVJnrZBpZGCmuty7FxDYj
// Component: 5uLBIAuPMivv
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import TeammateCard from "../../TeammateCard"; // plasmic-import: v8UWVOLwo7Y3/component
import { _useStyleTokens } from "../o_21_p_team_2_0_0_prod/PlasmicStyleTokensProvider"; // plasmic-import: cGVJnrZBpZGCmuty7FxDYj/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import "../o_21_p_team_2_0_0_prod/plasmic.css"; // plasmic-import: cGVJnrZBpZGCmuty7FxDYj/projectcss
import sty from "./PlasmicHomepage.module.css"; // plasmic-import: 5uLBIAuPMivv/css
import image357Uz453NK0Kc from "../o_21_p_team_2_0_3_prod/images/image35.jpg"; // plasmic-import: 7UZ453nK_0Kc/picture
import image367YrmQkYzrheq from "../o_21_p_team_2_0_3_prod/images/image36.jpg"; // plasmic-import: 7yrmQkYZRHEQ/picture

const emptyProxy = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  }
});

function wrapQueriesWithLoadingProxy($q) {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    }
  });
}

export function generateDynamicMetadata($q, $ctx) {
  return {
    title: "o21p | team",
    openGraph: {
      title: "o21p | team"
    },
    twitter: {
      card: "summary",
      title: "o21p | team"
    }
  };
}

createPlasmicElementProxy;

export const PlasmicHomepage__VariantProps = new Array();

export const PlasmicHomepage__ArgProps = new Array("onClick2");

const $$ = {};

function PlasmicHomepage__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const styleTokensClassNames = _useStyleTokens();
  return (
    <React.Fragment>
      <div
        data-plasmic-name={"root"}
        data-plasmic-override={overrides.root}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          "all",
          "root_reset_cGVJnrZBpZGCmuty7FxDYj",
          "plasmic_default_styles",
          "plasmic_mixins",
          styleTokensClassNames,
          sty.root,
          "no-scroll"
        )}
      >
        <div
          data-plasmic-name={"everything"}
          data-plasmic-override={overrides.everything}
          className={classNames("all", sty.everything, "auto-scroll")}
        >
          <section
            data-plasmic-name={"heroSection"}
            data-plasmic-override={overrides.heroSection}
            className={classNames("all", sty.heroSection)}
          >
            <div
              data-plasmic-name={"containerWrap"}
              data-plasmic-override={overrides.containerWrap}
              className={classNames("all", sty.containerWrap)}
            >
              <div
                data-plasmic-name={"nav"}
                data-plasmic-override={overrides.nav}
                className={classNames("all", sty.nav)}
              >
                <div className={classNames("all", sty.freeBox__sDcJ)}>
                  <div
                    className={classNames("all", "__wab_text", sty.text__kFCvU)}
                  >
                    {"["}
                  </div>
                  <div className={classNames("all", sty.freeBox__ugq6H)}>
                    <h1
                      className={classNames(
                        "all",
                        "h1",
                        "h1__cGVJn",
                        "__wab_text",
                        sty.h1__dQbis
                      )}
                    >
                      <React.Fragment>
                        <React.Fragment>{""}</React.Fragment>
                        {
                          <PlasmicLink__
                            className={classNames(
                              "all",
                              "a",
                              "a__cGVJn",
                              "__wab_text",
                              "plasmic_default__inline",
                              sty.link__nrjoL
                            )}
                            href={"https://o21p.com/"}
                            platform={"react"}
                          >
                            {"o21p"}
                          </PlasmicLink__>
                        }
                        <React.Fragment>{""}</React.Fragment>
                      </React.Fragment>
                    </h1>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text___75P2E
                      )}
                    >
                      {"|"}
                    </div>
                    <h1
                      className={classNames(
                        "all",
                        "h1",
                        "h1__cGVJn",
                        "__wab_text",
                        sty.h1___5ZBoI
                      )}
                    >
                      <React.Fragment>
                        <React.Fragment>{""}</React.Fragment>
                        {
                          <PlasmicLink__
                            className={classNames(
                              "all",
                              "a",
                              "a__cGVJn",
                              "__wab_text",
                              "plasmic_default__inline",
                              sty.link___9WzJh
                            )}
                            href={`/`}
                            platform={"react"}
                          >
                            {"team"}
                          </PlasmicLink__>
                        }
                        <React.Fragment>{""}</React.Fragment>
                      </React.Fragment>
                    </h1>
                  </div>
                  <div
                    className={classNames(
                      "all",
                      "__wab_text",
                      sty.text___8ZaXv
                    )}
                  >
                    {"]"}
                  </div>
                </div>
              </div>
              <div
                data-plasmic-name={"sectionContents00"}
                data-plasmic-override={overrides.sectionContents00}
                className={classNames("all", sty.sectionContents00)}
              >
                <h2
                  className={classNames(
                    "all",
                    "h2",
                    "h2__cGVJn",
                    "__wab_text",
                    sty.h2__dDnLi
                  )}
                >
                  {"// CAUSE"}
                </h2>
                <div
                  data-plasmic-name={"contents00"}
                  data-plasmic-override={overrides.contents00}
                  className={classNames("all", sty.contents00)}
                >
                  <p
                    className={classNames(
                      "all",
                      "p",
                      "p__cGVJn",
                      "__wab_text",
                      sty.p__m5V0
                    )}
                  >
                    {
                      "We imagine a world in which the independent lives and works on their own terms, preserving autonomy and identity within increasingly complex systems."
                    }
                  </p>
                  <p
                    className={classNames(
                      "all",
                      "p",
                      "p__cGVJn",
                      "__wab_text",
                      sty.p__o3ZTr
                    )}
                  >
                    {
                      "In an era obsessed with optimizing everything and everyone, we choose to empower the unrepeatable self. We stand with those who still think, feel, and choose for themselves. These are the truths we work from, the future we\u2019re building toward, and the values we refuse to compromise."
                    }
                  </p>
                </div>
              </div>
            </div>
          </section>
          <section
            data-plasmic-name={"section1"}
            data-plasmic-override={overrides.section1}
            className={classNames("all", sty.section1)}
          >
            <div
              data-plasmic-name={"containerWrapper"}
              data-plasmic-override={overrides.containerWrapper}
              className={classNames("all", sty.containerWrapper)}
            >
              <div
                data-plasmic-name={"sectionContents002"}
                data-plasmic-override={overrides.sectionContents002}
                className={classNames("all", sty.sectionContents002)}
              >
                <h2
                  className={classNames(
                    "all",
                    "h2",
                    "h2__cGVJn",
                    "__wab_text",
                    sty.h2__b2KwN
                  )}
                >
                  {"//  TEAM"}
                </h2>
                <div
                  data-plasmic-name={"contents002"}
                  data-plasmic-override={overrides.contents002}
                  className={classNames("all", sty.contents002)}
                >
                  <TeammateCard
                    className={classNames(
                      "__wab_instance",
                      sty.teammateCard__kWmdw
                    )}
                    mateName={"CRISTIAN"}
                    photo={
                      <PlasmicImg__
                        alt={""}
                        className={classNames(sty.img___4Pw)}
                        displayHeight={"auto"}
                        displayMaxHeight={"none"}
                        displayMaxWidth={"100%"}
                        displayMinHeight={"0"}
                        displayMinWidth={"0"}
                        displayWidth={"auto"}
                        loading={"lazy"}
                        src={{
                          src: image357Uz453NK0Kc,
                          fullWidth: 1269,
                          fullHeight: 1460,
                          aspectRatio: undefined
                        }}
                      />
                    }
                  />

                  <TeammateCard
                    className={classNames(
                      "__wab_instance",
                      sty.teammateCard__yxeL9
                    )}
                    mateName={"IULIAN"}
                    photo={
                      <PlasmicImg__
                        alt={""}
                        className={classNames(sty.img___1F62)}
                        displayHeight={"auto"}
                        displayMaxHeight={"none"}
                        displayMaxWidth={"100%"}
                        displayMinHeight={"0"}
                        displayMinWidth={"0"}
                        displayWidth={"auto"}
                        loading={"lazy"}
                        src={{
                          src: image367YrmQkYzrheq,
                          fullWidth: 1269,
                          fullHeight: 1460,
                          aspectRatio: undefined
                        }}
                      />
                    }
                  />

                  <TeammateCard
                    className={classNames(
                      "__wab_instance",
                      sty.teammateCard__lkbm7
                    )}
                    isPlaceholder={true}
                    mateName={"//"}
                    photo={
                      <PlasmicImg__
                        alt={""}
                        className={classNames(sty.img__wu3Vd)}
                        displayHeight={"auto"}
                        displayMaxHeight={"none"}
                        displayMaxWidth={"100%"}
                        displayMinHeight={"0"}
                        displayMinWidth={"0"}
                        displayWidth={"auto"}
                        loading={"lazy"}
                        src={{
                          src: image367YrmQkYzrheq,
                          fullWidth: 1269,
                          fullHeight: 1460,
                          aspectRatio: undefined
                        }}
                      />
                    }
                  />
                </div>
              </div>
              <div
                data-plasmic-name={"sectionContents003"}
                data-plasmic-override={overrides.sectionContents003}
                className={classNames("all", sty.sectionContents003)}
              >
                <h2
                  className={classNames(
                    "all",
                    "h2",
                    "h2__cGVJn",
                    "__wab_text",
                    sty.h2__nyiqm
                  )}
                >
                  {"// THE INDEPENDENT"}
                </h2>
                <div
                  data-plasmic-name={"contents003"}
                  data-plasmic-override={overrides.contents003}
                  className={classNames("all", sty.contents003)}
                >
                  <p
                    className={classNames(
                      "all",
                      "p",
                      "p__cGVJn",
                      "__wab_text",
                      sty.p__adR9L
                    )}
                  >
                    {
                      "The independent is the individual who treats work as a form of personal expression, builds a personal system to do it on his or her terms, and assumes direct responsibility for the decisions, standards, and outcomes that shape the work as it reaches others."
                    }
                  </p>
                  <p
                    className={classNames(
                      "all",
                      "p",
                      "p__cGVJn",
                      "__wab_text",
                      sty.p__d0D8K
                    )}
                  >
                    {
                      "The personal system he or she builds -- practice, studio, agency, firm, or something that doesn\u2019t even have a name yet -- is the environment that creates the conditions for his or her best work, and the vehicle through which that work becomes contribution."
                    }
                  </p>
                </div>
              </div>
              <div
                data-plasmic-name={"sectionContents004"}
                data-plasmic-override={overrides.sectionContents004}
                className={classNames("all", sty.sectionContents004)}
              >
                <h2
                  className={classNames(
                    "all",
                    "h2",
                    "h2__cGVJn",
                    "__wab_text",
                    sty.h2__ro6J
                  )}
                >
                  {"// MISSION"}
                </h2>
                <div
                  data-plasmic-name={"contents004"}
                  data-plasmic-override={overrides.contents004}
                  className={classNames("all", sty.contents004)}
                >
                  <p
                    className={classNames(
                      "all",
                      "p",
                      "p__cGVJn",
                      "__wab_text",
                      sty.p__rkW3U
                    )}
                  >
                    {
                      "Empower the independent to navigate the 21st-century digital world without sacrificing autonomy."
                    }
                  </p>
                </div>
              </div>
              <div
                data-plasmic-name={"sectionContents005"}
                data-plasmic-override={overrides.sectionContents005}
                className={classNames("all", sty.sectionContents005)}
              >
                <h2
                  className={classNames(
                    "all",
                    "h2",
                    "h2__cGVJn",
                    "__wab_text",
                    sty.h2__mneG3
                  )}
                >
                  {"// WORK"}
                </h2>
                <div
                  data-plasmic-name={"contents005"}
                  data-plasmic-override={overrides.contents005}
                  className={classNames("all", sty.contents005)}
                >
                  <p
                    className={classNames(
                      "all",
                      "p",
                      "p__cGVJn",
                      "__wab_text",
                      sty.p___3NkDa
                    )}
                  >
                    {"We design and build human-scale digital infrastructure."}
                  </p>
                </div>
              </div>
            </div>
          </section>
          <section
            data-plasmic-name={"section999"}
            data-plasmic-override={overrides.section999}
            className={classNames("all", sty.section999)}
          >
            <div className={classNames("all", sty.freeBox__kxsfp)}>
              <div className={classNames("all", "__wab_text", sty.text__yE07D)}>
                {
                  "\u00a92026 o21p -- all rights reserved. Contact us via email at team@o21p.com"
                }
              </div>
            </div>
          </section>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "everything",
    "heroSection",
    "containerWrap",
    "nav",
    "sectionContents00",
    "contents00",
    "section1",
    "containerWrapper",
    "sectionContents002",
    "contents002",
    "sectionContents003",
    "contents003",
    "sectionContents004",
    "contents004",
    "sectionContents005",
    "contents005",
    "section999"
  ],

  everything: [
    "everything",
    "heroSection",
    "containerWrap",
    "nav",
    "sectionContents00",
    "contents00",
    "section1",
    "containerWrapper",
    "sectionContents002",
    "contents002",
    "sectionContents003",
    "contents003",
    "sectionContents004",
    "contents004",
    "sectionContents005",
    "contents005",
    "section999"
  ],

  heroSection: [
    "heroSection",
    "containerWrap",
    "nav",
    "sectionContents00",
    "contents00"
  ],

  containerWrap: ["containerWrap", "nav", "sectionContents00", "contents00"],
  nav: ["nav"],
  sectionContents00: ["sectionContents00", "contents00"],
  contents00: ["contents00"],
  section1: [
    "section1",
    "containerWrapper",
    "sectionContents002",
    "contents002",
    "sectionContents003",
    "contents003",
    "sectionContents004",
    "contents004",
    "sectionContents005",
    "contents005"
  ],

  containerWrapper: [
    "containerWrapper",
    "sectionContents002",
    "contents002",
    "sectionContents003",
    "contents003",
    "sectionContents004",
    "contents004",
    "sectionContents005",
    "contents005"
  ],

  sectionContents002: ["sectionContents002", "contents002"],
  contents002: ["contents002"],
  sectionContents003: ["sectionContents003", "contents003"],
  contents003: ["contents003"],
  sectionContents004: ["sectionContents004", "contents004"],
  contents004: ["contents004"],
  sectionContents005: ["sectionContents005", "contents005"],
  contents005: ["contents005"],
  section999: ["section999"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHomepage__ArgProps,
          internalVariantPropNames: PlasmicHomepage__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHomepage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicHomepage";
  } else {
    func.displayName = `PlasmicHomepage.${nodeName}`;
  }
  return func;
}

export const PlasmicHomepage = Object.assign(
  // Top-level PlasmicHomepage renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    everything: makeNodeComponent("everything"),
    heroSection: makeNodeComponent("heroSection"),
    containerWrap: makeNodeComponent("containerWrap"),
    nav: makeNodeComponent("nav"),
    sectionContents00: makeNodeComponent("sectionContents00"),
    contents00: makeNodeComponent("contents00"),
    section1: makeNodeComponent("section1"),
    containerWrapper: makeNodeComponent("containerWrapper"),
    sectionContents002: makeNodeComponent("sectionContents002"),
    contents002: makeNodeComponent("contents002"),
    sectionContents003: makeNodeComponent("sectionContents003"),
    contents003: makeNodeComponent("contents003"),
    sectionContents004: makeNodeComponent("sectionContents004"),
    contents004: makeNodeComponent("contents004"),
    sectionContents005: makeNodeComponent("sectionContents005"),
    contents005: makeNodeComponent("contents005"),
    section999: makeNodeComponent("section999"),
    // Metadata about props expected for PlasmicHomepage
    internalVariantProps: PlasmicHomepage__VariantProps,
    internalArgProps: PlasmicHomepage__ArgProps,
    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/",
      pagePath: "/",
      params: {},
      query: {}
    })
  }
);

export default PlasmicHomepage;
/* prettier-ignore-end */
